<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item> 燃烧币种分红</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      <div class="page-actions"></div>
      <el-table :data="listData">
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column label="项目方ID" prop="projectId"></el-table-column>
        <el-table-column
          label="项目方分红比例"
          prop="projectBounsRate"
        ></el-table-column>
        <el-table-column
          label="卖单手续费率"
          prop="askFeeRate"
        ></el-table-column>
        <el-table-column
          label="买单手续费率"
          prop="bidFeeRate"
        ></el-table-column>
        <el-table-column
          label="卖单分红比例"
          prop="askBounsRate"
        ></el-table-column>
        <el-table-column
          label="买单分红比例"
          prop="bidBounsRate"
        ></el-table-column>
        <el-table-column label="上次分红时间" prop="lastBounsTime">
          <template slot-scope="scope">{{
            scope.row.lastBounsTime | moment
          }}</template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">{{
            scope.row.createTime | moment
          }}</template>
        </el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            {{ scope.row.status ? '开启' : '不开启' }}
          </template>
        </el-table-column>
        <el-table-column label="查询分红纪录">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="toGoPage(scope.row.id, scope.row.lastBounsTime)"
              >查看页面
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="listCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </el-card>
  </div>
</template>
<script>
import '../store';
import Pagination from 'components/pagination';
import { mapActions, mapState } from 'vuex';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: 20
    };
  },
  computed: {
    ...mapState('burnCoinBonus', ['listData', 'listCount', 'pagination'])
  },
  methods: {
    ...mapActions('burnCoinBonus', ['getList']),
    refreshList(data) {
      this.getList({
        ...this.pagination,
        ...data
      });
    },
    handleCurrentChange(pageVal) {
      this.refreshList(pageVal);
    },
    closeDialog() {
      this.editInfo = {};
      this.dialogShow = false;
    },
    toGoPage(id, lastBounsTime) {
      const routerJump = this.$router.resolve({
        path: '/home/entries/BonusRecord',
        query: { id, lastBounsTime }
      });
      window.open(routerJump.href, '_self');
    }
  },
  mounted() {
    this.refreshList();
  }
};
</script>
<style lang="less" scoped></style>
